import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import {provideRouter, withHashLocation, withInMemoryScrolling} from '@angular/router';

import {routes} from './app.routes';
import {provideClientHydration} from '@angular/platform-browser';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideHttpClient, withFetch, withInterceptors} from "@angular/common/http";
import {apiInterceptor} from "./theme/admin/interceptors/api.interceptor";
import {loaderInterceptor} from "./theme/admin/interceptors/loader.interceptor";
import {LoaderService} from "./theme/admin/services/loader.service";
import {TranslateModule} from "@ngx-translate/core";
import {DatePipe} from "@angular/common";

export const appConfig: ApplicationConfig = {
  providers: [DatePipe, provideRouter(routes, withInMemoryScrolling(), withInMemoryScrolling()), provideClientHydration(), provideAnimations(), provideHttpClient(withFetch(), withInterceptors([apiInterceptor, loaderInterceptor(new LoaderService)])), importProvidersFrom(TranslateModule.forRoot())]
};
